import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './Vacatures.css'

function Vacatures() {
  const [vacatures, setVacatures] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL}/api/vacatures?sort=createdAt:desc`)
      .then((res) => {
        if (!res.ok) throw new Error('Kon vacatures niet laden.')
        return res.json()
      })
      .then((data) => {
        setVacatures(data.data || [])
        setLoading(false)
      })
      .catch((err) => {
        setError(err.message)
        setLoading(false)
      })
  }, [])

  const parseList = (text) =>
    text ? text.split('\n').map((l) => l.trim()).filter(Boolean) : []

  return (
    <div className="vacatures">
      <div className="vacatures-header">
        <h1>Vacatures</h1>
        <p className="subtitle">Word deel van het CarWrap Artist team.</p>
      </div>

      {loading && <p className="vacatures-status">Vacatures laden...</p>}
      {error && <p className="vacatures-status vacatures-error">{error}</p>}

      {!loading && !error && vacatures.length === 0 && (
        <p className="vacatures-status">
          Momenteel zijn er geen openstaande vacatures. Stuur gerust een spontane sollicitatie!
        </p>
      )}

      {!loading && !error && vacatures.length > 0 && (
        <div className="vacatures-list">
          {vacatures.map((v) => {
            const { titel, type, locatie, beschrijving, vereisten, aanbod } = v.attributes
            return (
              <div key={v.id} className="vacature-card">
                <div className="vacature-top">
                  <div>
                    <h2>{titel}</h2>
                    <div className="vacature-meta">
                      <span className="badge">📍 {locatie}</span>
                      <span className="badge">⏱ {type}</span>
                    </div>
                  </div>
                  <Link
                    to={`/contact?service=${encodeURIComponent('Sollicitatie: ' + titel)}`}
                    className="btn-solliciteer"
                  >
                    Solliciteer
                  </Link>
                </div>

                <p className="vacature-beschrijving">{beschrijving}</p>

                {(vereisten || aanbod) && (
                  <div className="vacature-details">
                    {vereisten && (
                      <div className="detail-block">
                        <h4>Wat we vragen</h4>
                        <ul>
                          {parseList(vereisten).map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {aanbod && (
                      <div className="detail-block">
                        <h4>Wat we bieden</h4>
                        <ul>
                          {parseList(aanbod).map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}

      <div className="spontaan-card">
        <h2>Niets voor jou?</h2>
        <p>
          Stuur ons een spontane sollicitatie. We zijn altijd op zoek naar gemotiveerde mensen
          die iets willen betekenen bij CarWrap Artist.
        </p>
        <Link to="/contact?service=Spontane sollicitatie" className="btn-solliciteer">
          Spontaan solliciteren
        </Link>
      </div>
    </div>
  )
}

export default Vacatures
